<template>
  <div class="revt-page" v-cloak>
    <header-nav :current="current"></header-nav>
    <!-- 阶段量表开始提示 -->
    <div class="exam-stage" v-if="step === 0 && showStagePage">
      <div class="state-shadow"></div>
      <div class="exam-stage-cate">
        <div class="exam-stage-cate-title">
          汉语儿童理解与表达词汇测验
        </div>
        <div class="exam-next-btn">
          <span class="span-btn" @click="showBaseForm">下一步</span>
        </div>
      </div>
    </div>
    <div class="base-info-container" v-if="step === 1 && !showStagePage">
      <el-form ref="baseForm" :model="baseForm" size="small">
        <div class="base-form-container">
          <div class="base-info-left">
            <div class="base-info-label">
              基本信息
            </div>
            <div class="base-info-form">
              <el-form-item class="base-input-item is-required " label="所在城市" prop="place">
                <div style="display: flex" class="area">
                  <el-select v-model="baseForm.province" filterable @change="choose($event,'city')" placeholder="请选择省份"
                             :popper-append-to-body="false">
                    <el-option v-for="(item,index) in province" :key="index" :label="item.area_name"
                               :value="item.area_name"></el-option>
                  </el-select>
                  <el-select class="select-group group-select-list" filterable @change="choose($event,'district')"
                             v-model="baseForm.city" placeholder="请选择城市" :popper-append-to-body="false">
                    <el-option v-for="(item,index) in city" :key="index" :label="item.area_name"
                               :value="item.area_name"></el-option>
                  </el-select>
                  <el-select class="group-select-list" filterable @change="choose($event)" v-model="baseForm.district" placeholder="请选择县/区"
                             :popper-append-to-body="false">
                    <el-option v-for="(item,index) in areas" :key="index" :label="item.area_name"
                               :value="item.area_name"></el-option>
                  </el-select>
                </div>
              </el-form-item>
<!--              <div class="input-tip-alert">优先填入监护人手机号和儿童姓名可以加载儿童已录入公共信息。</div>-->
              <el-form-item class="base-input-item is-required" label="监护人手机号" prop="mobile">
                <el-input placeholder="请填写监护人手机号" autocomplete="off" v-model="baseForm.mobile"></el-input>
              </el-form-item>
              <el-form-item class="base-input-item is-required" label="儿童姓名" prop="name">
                <el-input placeholder="请填写儿童姓名" autocomplete="off" v-model="baseForm.name"></el-input>
              </el-form-item>
              <el-form-item class="base-input-item is-required" label="性别" prop="sex">
                <el-select v-model="baseForm.sex" placeholder="请选择性别" :popper-append-to-body="false">
                  <el-option label="男生" value="男生"></el-option>
                  <el-option label="女生" value="女生"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="base-input-item is-required" label="就读学校" prop="school">
                <el-input placeholder="请填写就读学校" autocomplete="off" v-model="baseForm.school"></el-input>
              </el-form-item>
              <el-form-item class="base-input-item is-required" label="填写日期" prop="exam_date">
                <el-date-picker type="date" placeholder="请选择填写日期" @change="chooseDate($event,'input')" v-model="baseForm.exam_date"
                                style="width: 100%;"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" :picker-options="forbiddenStartTime"></el-date-picker>
              </el-form-item>
              <el-form-item class="base-input-item is-required" label="出生日期" prop="birthday">
                <el-date-picker type="date" placeholder="请选择出生日期" @change="chooseDate($event,'birthday')" v-model="baseForm.birthday"
                                style="width: 100%;"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                :picker-options="forbiddenStartTime"></el-date-picker>
              </el-form-item>
              <el-form-item class="base-input-item " label="实足年龄">
                <el-input placeholder="实足年龄，根据填写日期与出生日期计算。" disabled autocomplete="off"
                          v-model="age"></el-input>
              </el-form-item>
              <el-form-item class="base-input-item is-required" label="转介者" prop="referral_user">
                <el-input placeholder="请填写转介者" autocomplete="off" v-model="baseForm.referral_user"></el-input>
              </el-form-item>
              <el-form-item class="base-input-item " label="转介理由">
                <el-input placeholder="请填写转介理由" autocomplete="off" v-model="baseForm.referral_reason"></el-input>
              </el-form-item>
              <el-form-item class="base-input-item is-required" label="施测人员" prop="operator">
                <el-input placeholder="请填写施测人员" autocomplete="off" v-model="baseForm.operator"></el-input>
              </el-form-item>
              <el-form-item class="base-input-item " label="施测地点">
                <el-select v-model="baseForm.operator_area" placeholder="请选择施测地点" :popper-append-to-body="false">
                  <el-option label="干预机构" value="干预机构"></el-option>
                  <el-option label="医院" value="医院"></el-option>
                  <el-option label="家中" value="家中"></el-option>
                  <el-option label="学校" value="学校"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="base-info-right" v-if="isOver">
            <div class="base-info-label">
              超龄儿童基本资料
            </div>
            <div class="base-info-form">
              <el-form-item class="base-input-item is-required" label="家中排行">
                <el-select v-model="baseForm.rank" placeholder="请选择家中排行" prop="rank"
                           :popper-append-to-body="false">
                  <el-option label="老大" value="老大"></el-option>
                  <el-option label="中间" value="中间"></el-option>
                  <el-option label="最小" value="最小"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="base-input-item is-required" label="家庭儿童人数">
                <el-select v-model="baseForm.children_num" placeholder="请选择家庭儿童人数" prop="children_num"
                           :popper-append-to-body="false">
                  <el-option :label="num" :value="num" v-for="num in 6" :key="num"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="base-select-item is-required" label="就读" prop="school_type">
                <div class="base-input-other">
                  <el-select v-model="baseForm.school_type" placeholder="请选择就读机构、学校"
                             :popper-append-to-body="false">
                    <el-option label="托儿所" value="托儿所"></el-option>
                    <el-option label="普通幼儿园" value="普通幼儿园"></el-option>
                    <el-option label="融合幼儿园" value="融合幼儿园"></el-option>
                    <el-option label="小学" value="小学"></el-option>
                    <el-option label="其他" value="其他"></el-option>
                  </el-select>
                  <el-input autocomplete="off" v-if="baseForm.school_type === '其他'" placeholder="请填写就读机构、学校"
                            v-model="baseForm.school_type_other"></el-input>
                </div>
              </el-form-item>
              <el-form-item class="base-select-item is-required" label="主要照顾者" prop="care_man">
                <div class="base-input-other">
                  <el-select v-model="baseForm.care_man" placeholder="请选择主要照顾者" :popper-append-to-body="false">
                    <el-option label="母亲" value="母亲"></el-option>
                    <el-option label="父亲" value="父亲"></el-option>
                    <el-option label="其他" value="其他"></el-option>
                  </el-select>
                  <el-input autocomplete="off" v-if="baseForm.care_man === '其他'" placeholder="请填写主要照顾者"
                            v-model="baseForm.care_man_other"></el-input>
                </div>
              </el-form-item>
              <el-form-item class="base-input-item " label="家中主要使用语言">
                <el-input placeholder="请填写家中主要使用语言" autocomplete="off"
                          v-model="baseForm.language"></el-input>
              </el-form-item>
              <el-form-item class="base-select-item is-required" label="双亲国籍" prop="nationality">
                <div class="base-input-other">
                  <el-select v-model="baseForm.nationality" placeholder="请选择双亲国籍" :popper-append-to-body="false">
                    <el-option label="均为本国籍" value="均为本国籍"></el-option>
                    <el-option label="其中一方为本国籍" value="其中一方为本国籍"></el-option>
                    <el-option label="其他" value="其他"></el-option>
                  </el-select>
                  <el-input autocomplete="off" v-if="baseForm.nationality === '其他'" placeholder="请填写主要照顾者"
                            v-model="baseForm.nationality_other"></el-input>
                </div>
              </el-form-item>
              <el-form-item class="base-input-item is-required" label="领有身障手册" prop="obstacle_book">
                <el-select v-model="baseForm.obstacle_book" placeholder="请选择是否领有身障手册"
                           :popper-append-to-body="false">
                  <el-option label="未领有" value="未领有"></el-option>
                  <el-option label="已领有" value="已领有"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="base-input-item " label="障碍程度">
                <el-select v-model="baseForm.obstacle_level" placeholder="请选择障碍程度"
                           :popper-append-to-body="false">
                  <el-option label="无" value="无"></el-option>
                  <el-option label="轻" value="轻"></el-option>
                  <el-option label="中" value="中"></el-option>
                  <el-option label="重" value="重"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="base-input-item " label="障碍类别">
                <el-input placeholder="请填写障碍类别" autocomplete="off" v-model="baseForm.obstacle_type"></el-input>
              </el-form-item>
            </div>
          </div>
        </div>

      </el-form>
      <div class="base-form-button">
        <el-button class="form-submit-btn" @click="baseSubmit">下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderNav from '@/components/HeaderNav'

export default {
  name: 'revt',
  data () {
    return {
      step: 0,
      showStagePage: true,
      province: [],
      city: [],
      areas: [],
      current: '',
      baseForm: {
        province: '',
        city: '',
        district: '',
        mobile:'',
        name: '',
        sex: '',
        school: '',
        area: '',
        exam_date: '',
        birthday: '',
        age: '',
        month: '',
        referral_user: '',
        referral_reason: '',
        operator: '',
        operator_area: '',
        rank: '',
        children_num: 1,
        school_type: '',
        school_type_other: '',
        care_man: '',
        care_man_other: '',
        language: '',
        nationality: '',
        nationality_other: '',
        obstacle_book: '',
        obstacle_level: '',
        obstacle_type: ''
      },
      inputing: null,
      oldName: '',
      age:'',
      month:0,
      isOver:false,
      baseWidth:1920,
      forbiddenStartTime:{ //禁用当前日期之后的日期
        disabledDate: this.disabledDateMethod,
      }
    }
  },
  mounted () {
    this.resizeScale()
    this.baseForm.exam_date = this.getCurrentDate()
    window.addEventListener('keydown', this.spaceKeyDownHandler)
    window.addEventListener('resize',this.resizeScale)
  },
  created () {
    this.getAreas()
  },
  methods: {
    disabledDateMethod(time) {
      // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
      return time.getTime() > Date.now() - 8.64e6
    },
    resizeScale(){
      let screenWidth = document.documentElement.clientWidth
      let scale = screenWidth / this.baseWidth
      let page = document.querySelector('.revt-page')
      page.style.setProperty('--scale', scale)
      this.codeSize = 100 * scale
    },
    // 展示题目信息
    showBaseForm () {
      this.step++
      this.showStagePage = false
    },
    /**
     * 监听空格事件
     * @param event
     */
    spaceKeyDownHandler (event) {
      if (event.keyCode == 32 && this.step === 0) {
        this.showBaseForm()
      }
    },
    baseSubmit () {
      let form = this.baseForm

      let mustInputBase = ['province','city','mobile','name','school','exam_date','birthday','referral_user','operator']
      let overBase = ['rank','children_num','school_type','care_man','nationality','obstacle_book']
      let overBaseOther = ['school_type_other','care_man_other','nationality_other']
      for (let i in form) {
        if (mustInputBase.indexOf(i) > -1 && form[i].length === 0){
          this.$layer.msg('带有红色角标的为必填项，请填写完整后再进行操作。')
          return false
        }
        if (this.month >= 84){
          // 超龄
          if (overBase.indexOf(i) > -1 && (!form[i] || form[i].length === 0)){
            this.$layer.msg('带有红色角标的为必填项，请填写完整后再进行操作。')
            return false
          }
          if (overBase.indexOf(i) > -1 && form[i] === '其他'){
            let other = i+'_other';
            if(overBaseOther.indexOf(other) > -1 && (!form[other] || form[other].length === 0)){
              this.$layer.msg('带有红色角标的为必填项，请填写完整后再进行操作；请留意是否有输入框未填写。')
              return false
            }
            if (overBaseOther.indexOf(other) > -1 && form[other] && form[other].length > 0){
              form[i] = form[other]
              delete form[other]
            }
          }
        }
      }
      if (form.mobile.length !== 11){
        this.$layer.msg('请填写正确的监护人手机号')
        return false
      }
      form.title_id = this.$route.query.id;
      form.age = this.age
      form.month = this.month
      this.$post('exam/saveBaseInfo', form).then(res => {
        if (res.code === 1){
          // 跳转到施测
          // res.data.exam_id
          this.$router.push('/revt_test?eid='+this.$route.query.id+'&exam_id='+res.data.exam_id)
        }
      })
    },
    getAreas (type = 'province', id = 0) {
      let params = {area_id: id}
      this.$post('index/getArea', params).then((res) => {
        if (res.code === 1) {
          if (type === 'province') {
            this.province = res.data
          } else if (type === 'city') {
            this.city = res.data
          } else if (type === 'district') {
            this.areas = res.data
          }
        }
      })
    },
    choose (e, type = '') {
      let areaId
      switch (type) {
        case 'city':
          areaId = this.province.find(item => item.area_name === e).area_id;
          this.city = []
          this.areas = []
          this.baseForm.city = ''
          this.baseForm.district = ''
          break
        case 'district':
          this.baseForm.district = ''
          areaId = this.city.find(item => item.area_name === e).area_id;
          break
      }
      if (type && type.length > 0) {
        this.getAreas(type, areaId)
      }
    },
    /**
     * 获取儿童历史资料
     * @param mobile
     * @param name
     */
    getChildInfo (mobile, name) {
      return false
      let oldForm = JSON.parse(JSON.stringify(this.baseForm))
      this.$post('exam/childBase', {mobile: mobile, name: name, title_id: this.$route.query.id}).then(res => {
        if (res.code === 1) {
          res.data.mobile = oldForm.mobile
          this.baseForm = res.data
          // if ((res.data.province && res.data.province.length === 0) || !res.data.province){
          //   this.baseForm.province = oldForm.province
          //   this.baseForm.city = oldForm.city
          //   this.baseForm.district = oldForm.district.length > 0 ? oldForm.district : ''
          // }
          this.$nextTick(() => {
            this.$refs.baseForm.clearValidate()
          })
        }
        this.baseForm.exam_date = this.getCurrentDate()
        if (this.baseForm.exam_date.length > 0 && this.baseForm.birthday.length > 0){
          this.calculateAge(this.baseForm.exam_date,this.baseForm.birthday)
        }
      })
    },
    checkInputPhone () {
      let reg = /^1[3456789]\d{9}$/
      if (!reg.test(this.baseForm.mobile)) {
        this.$layer.msg('监护人手机号码格式错误！')
        return false
      }
      return true
    },
    chooseDate(e,type){
      switch (type) {
        case 'input':
          if(this.baseForm.birthday.length > 0){
            this.calculateAge(e,this.baseForm.birthday)
          }
          break
        case 'birthday':
          if (this.baseForm.exam_date.length > 0){
            this.calculateAge(this.baseForm.exam_date,e)
          }
          break
      }
    },
    calculateAge(examDate, birthdayDate) {
      const birthDate = new Date(birthdayDate);
      const currentDate = new Date(examDate);

      // 计算年份差
      let yearDiff = currentDate.getFullYear() - birthDate.getFullYear();

      // 计算月份差
      let monthDiff = currentDate.getMonth() - birthDate.getMonth();

      // 计算天数差
      let dayDiff = currentDate.getDate() - birthDate.getDate();

      console.log(dayDiff, '天数差：' + birthDate.getDate());

      // 关键修正：如果当前日期小于出生日期，月份减1
      if (dayDiff < 0) {
        monthDiff--; // 当前日期小于出生日期，借一个月
      }

      // 新增规则：天数差大于等于30天时，上进一个月
      if (dayDiff >= 30) {
        monthDiff++; // 天数差大于等于30天，上进一个月
      }

      // 调整月份和年份
      if (monthDiff < 0) {
        yearDiff--;
        monthDiff += 12;
      }

      // 如果月份超过12个月，调整年份
      if (monthDiff >= 12) {
        yearDiff += Math.floor(monthDiff / 12);
        monthDiff = monthDiff % 12;
      }

      // 计算总月数
      const totalMonths = yearDiff * 12 + monthDiff;

      // 格式化年龄和月数
      let age = '';
      if (!isNaN(yearDiff) && !isNaN(monthDiff)) {
        age = `${yearDiff}岁${monthDiff}个月`;
      } else {
        age = '';
      }

      console.log('总月数：', totalMonths);

      // 验证结果
      if (totalMonths < 0) {
        this.month = 0;
        this.age = '';
        this.$layer.msg('请选择正确的出生日期');
        this.baseForm.birthday = '';
      } else {
        this.month = totalMonths;
        this.age = age;
      }

      this.isOver = totalMonths >= 84;
    },
    getCurrentDate(){
      let now = new Date()
      let year = now.getFullYear()
      let month = now.getMonth() + 1
      let day = now.getDate()
      return `${year}-${month}-${day}`
    }

  },
  components: {
    HeaderNav
  },
  watch: {
    'baseForm.mobile' (val) {
      // clearTimeout(this.inputing)
      // this.inputing = setTimeout(() => {
      //   let check = this.checkInputPhone()
      //   if (this.baseForm.mobile.length > 0 && check) {
      //     this.getChildInfo(val, this.baseForm.name)
      //   }
      // }, 500)
    },
    'baseForm.name' (val,old) {
      // if (val !== old) {
      //   clearTimeout(this.inputing)
      //   this.inputing = setTimeout(() => {
      //     if (this.baseForm.mobile.length === 11) {
      //       let check = this.checkInputPhone()
      //       if (check) {
      //         this.oldName = val
      //         this.getChildInfo(this.baseForm.mobile, val)
      //       }
      //     }
      //   }, 1000)
      // }

      // if (val.length > 0 && this.oldName !== val) {
      //   clearTimeout(this.inputing)
      //   this.inputing = setTimeout(() => {
      //     this.oldName = val
      //     if (this.baseForm.mobile.length === 11) {
      //       let check = this.checkInputPhone()
      //       if (check) {
      //         this.getChildInfo(this.baseForm.mobile, val)
      //       }
      //     }
      //   }, 1000)
      // }
    }
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.spaceKeyDownHandler)
    window.removeEventListener('resize',this.resizeScale)
  }
}
</script>
<style>
.el-date-table td.current:not(.disabled) span {
  color: #FFF;
  background-color: #f39901;
}

.el-date-table td.today span {
  color: #f39901;
  font-weight: 700;
}

.el-date-table td.available:hover {
  color: #ffad23;
}

.el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner {
  border-color: #f39901;
}

.el-form-item__label {
  width: 140px;
  background-color: #fafafa;
  border: 1px solid #EEEEEE;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  box-sizing: border-box;
  border-right: none;
  font-weight: bold;
  color: #000;
  position: relative;
}
.is-required > .el-form-item__label:before {
  content: '*';
  position: absolute;
  right: 0;
  top: 50%;
  color: red;
  transform: translate(0, -38%);
  font-weight: bold;
}

.el-input.is-active .el-input__inner, .el-input__inner:focus {
  border-color: #f39901;
  outline: 0;
}

.el-select .el-input__inner:focus {
  border-color: #f39901 !important;
}

.el-select-dropdown__item.selected {
  color: #f39901 !important;
  font-weight: 700;
}

.base-input-item > div > div {
  display: inline-block;
  width: calc(100% - 140px) !important;
}

.select-group {
  margin: 0 10px;
}

.group-select-list > div > input {
  border-radius: 4px !important;
}

.base-input-other {
  display: flex;
  flex-direction: column;
  width: calc(100% - 140px);
}

.base-input-other > .el-input {
  margin-top: 1%;
}

.el-input--small .el-input__inner {
  height: 34px;
  line-height: 34px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  color: #000000 !important;
}

.el-form-item__error {
  margin-left: 140px !important;
}
</style>
<style scoped lang="less">
@import url('../assets/css/page/revt_baseinfo');
</style>